/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerListElementList = {
    type: 'array',
    contains: {
        type: 'PlayerListElement',
    },
} as const;
